import HeatmapLegend from './HeatmapLegend';

export default HeatmapLegend;
